var exports = {
  "k": "x24da60e8--48c0fe--container",
};

module.exports = exports;
